videojs.addLanguage('en', {
  "Include your own strings in JSON files.": "Include your own strings in JSON files.",
  "description": "Description of the video",
  "title": "General information of the video",
  "views": "views"
});


//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_info/dist/lang/en.js
// module id = 543
// module chunks = 39